import labels from "./labels";
import statuses from "./statuses";
import messages from "./messages";
import errors from "./errors";
import fields from "./fields";

export default {
    errors: errors,
    fields: fields,
    labels: labels,
    messages: messages,
    statuses: statuses,
}
